import { render, staticRenderFns } from "./UserInsights.vue?vue&type=template&id=540cd4ab&scoped=true&"
import script from "./UserInsights.vue?vue&type=script&lang=js&"
export * from "./UserInsights.vue?vue&type=script&lang=js&"
import style0 from "./UserInsights.vue?vue&type=style&index=0&id=540cd4ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540cd4ab",
  null
  
)

export default component.exports